import React from "react"
import PropTypes from "prop-types"

import css from "./Button.scss"

function Button({ as, label, type, isDisabled, onClick, iconUrl, size, block, className, htmlType }) {
    const Tag = as
    let classNames = [css.button, css[size]]
    if (block) {
        classNames.push(css.buttonBlock)
    }

    const disabledClass = {
        primary: css.disabledPrimary,
        secondary: css.disabledSecondary,
        tertiary: `${css.disabledSecondary} ${css.noOutline}`,
        textual: `${css.disabledSecondary} ${css.noOutline} ${css.widthFitContent} ${css.noPadding} ${css.noHeight}`,
    }

    const buttonClass = {
        primary: css.primary,
        secondary: css.secondary,
        tertiary: `${css.secondary} ${css.noOutline}  ${css.hoverTertiary}`,
        textual: `${css.secondary} ${css.noOutline} ${css.hoverTertiary} ${css.widthFitContent} ${css.noPadding} ${css.noHeight}`,
        underlined: `${css.underlined} ${css.widthFitContent}`,
        underlinedWhite: `${css.underlinedWhite}  ${css.widthFitContent}`,
    }

    classNames.push(!isDisabled ? buttonClass[type] : disabledClass[type])

    className && classNames.push(className)

    const buttonStyles = classNames.join(" ")

    return (
        <Tag
            onClick={onClick}
            className={`flex justifyCenter alignCenter ${buttonStyles}`}
            disabled={isDisabled}
            type={htmlType}
        >
            {iconUrl ? (
                <img src={iconUrl} className={label ? css.imageSpan : ""} alt="Icon" title="button" />
            ) : null}
            {label && (
                <span
                    className={` ${css.buttonText} ${
                        type === ("underlined" || "underlinedWhite") ? "bodyMedium" : "bodySemiBold"
                    } `}
                >
                    {label}
                </span>
            )}
        </Tag>
    )
}

Button.propTypes = {
    as: PropTypes.string,
    label: PropTypes.node,
    type: PropTypes.oneOf(["primary", "secondary", "tertiary", "underlined", "underlinedWhite", "textual"]),
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    size: PropTypes.oneOf(["small", "regular", "large"]),
    block: PropTypes.bool,
    iconUrl: PropTypes.string,
    className: PropTypes.string,
    htmlType: PropTypes.string,
}

Button.defaultProps = {
    as: "button",
    isDisabled: false,
    type: "primary",
    size: "regular",
    block: true,
    iconUrl: "",
    label: "",
    className: "",
    htmlType: "button",
}

export default Button
